export default class PageScroller {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.initialScroll();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Gets the accurate offsetTop of an element
  //===========================================================================

  getOffsetTop(el) {
    let offsetTop = 0;
    let element = el;

    while(element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }

    return offsetTop;
  }

  //===========================================================================
  // Scroll to a section on page load if there is an href hash
  //===========================================================================

  initialScroll() {
    const hash = window.location.hash;

    if (hash) {
      const $section = $(hash);

      if ($section.hasClass('js-faq-question')) {
        window.history.scrollRestoration = 'manual';

        if ($section.data('category')) {
          $(`.js-switch-link[data-type=${ $section.data('category') }]`).click();
        }

        this.scrollToSection(hash.replace('#', ''));
        $section.find('.js-accordion-header').click();
      } else if ($section.hasClass('js-faq-category')) {
        if ($section.data('type')) {
          $(`.js-switch-link[data-type=${ $section.data('type') }]`).click();
        }
      }

      this.scrollToSection(hash, true);
    }
  }

  //===========================================================================
  // Scrolls to a section based on the data-anchor attribute of the clicked link.
  // The section's ID must match the data-anchor
  // The link must have a js-scroll-to class
  //===========================================================================

  scrollToSectionOnClick(e) {
    const $target = $(e.currentTarget);
    const header = $('.js-header')[0];
    const headerHeight = header ? header.offsetHeight : 0;

    e.preventDefault();

    if ($target[0]) {
      this.scrollToSection($target.data('anchor'), true);
    }
  }

  //===========================================================================
  // Scrolls to a section
  //===========================================================================

  scrollToSection(anchor, animate) {
    const $section = anchor && anchor.includes('#') ? $(`${ anchor }`) : $(`#${ anchor }`);
    let top = this.getOffsetTop($section[0]);

    if (!$section.hasClass('scroll-anchor-section')) {
      top -= 130;
    }

    if (animate) {
      $('html').animate({
        scrollTop: top
      }, 'fast');
    } else {
      window.scrollTo(0, top);
    }
  }

  //===========================================================================
  // Scrolls up to .js-page-top element (But not down)
  //===========================================================================

  scrollToPageTop() {
    const $pageTop = $('.js-page-top');

    if ($pageTop[0]) {
      const $header = $('.js-header');
      const sectionTop = this.getOffsetTop($pageTop[0]);
      const topPadding = 30;
      const topBoundary = $header[0] ? $header[0].offsetHeight + topPadding : topPadding;
      const containerBounds = $pageTop[0].getBoundingClientRect();

      if (containerBounds) {
        $('html').animate({
          scrollTop: sectionTop - topBoundary
        }, 'fast');
      }
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-scroll-to', this.scrollToSectionOnClick.bind(this));
    $(document).on('scrollToPageTop', this.scrollToPageTop.bind(this));
    $(document).on('historyChange', this.initialScroll.bind(this));
  }
}
